import { render, staticRenderFns } from "./BaseSkeleton.vue?vue&type=template&id=66c40f21&scoped=true&"
import script from "./BaseSkeleton.vue?vue&type=script&lang=js&"
export * from "./BaseSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BaseSkeleton.vue?vue&type=style&index=0&id=66c40f21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c40f21",
  null
  
)

export default component.exports